const MANUAL_EDITION_MODE = 'manualEditionMode';
export default MANUAL_EDITION_MODE;
